var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.requiredHint") } },
    [
      _c("el-input", {
        attrs: { type: "text" },
        model: {
          value: _vm.optionModel.requiredHint,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "requiredHint", $$v)
          },
          expression: "optionModel.requiredHint",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }